import {
    CCard,
    CCardBody,
    CCardTitle,
    CCardText,
} from '@coreui/react';
import { useEffect, useState } from 'react';
import CookieFunctions from '../functions/CookieFunctions';
import { toast } from 'react-toastify';
import SafetyMessage from '../components/safety/SafetyMessage';

export default function SafetyMessages() {

    const [messages, setMessages] = useState([])

    function getAllMessages() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/drivers/messages/get",
            {
                headers: myHeaders,
                method: 'GET'
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            setMessages(data)
        }).catch((e) => {
            toast.error(e, {
                closeButton: true,
                autoClose: true,
                position: toast.POSITION.BOTTOM_CENTER,
                theme: "colored",
            })
        })
    }

    useEffect(() => {
        getAllMessages()
    }, [])

    return (
        <CCard className="mb-4">
            <CCardBody>
                <CCardTitle className='fs-2'>Safety Messages</CCardTitle>
                {/* Active messages */}
                <CCardTitle className='fs-4' style={{ marginTop: '30px', color: '#61B165' }}>Current</CCardTitle>
                <SafetyMessage messages={messages.filter((m) => new Date(m.expiry) > new Date())} />
                {/* Historical messages */}
                <CCardTitle className='fs-4' style={{ marginTop: '30px' }}>Past</CCardTitle>
                <SafetyMessage messages={messages.filter((m) => new Date(m.expiry) <= new Date())} />
            </CCardBody>
        </CCard>
    );
}
